import { altThemeVariables } from '../themes/alt-theme-variables';
import { careThemeVariables } from '../themes/care-theme-variables';
import { defaultThemeVariables } from '../themes/default-theme-variables';
import { myvmThemeVariables } from '../themes/myvm-theme-variables';
import { salesThemeVariables } from '../themes/sales-theme-variables';
import { salesVmo2ThemeVariables } from '../themes/sales-vmo2-theme-variables';
import { salesSimBoltOnThemeVariables } from '../themes/sales-sim-bolt-on-theme-variables';
import { vmo2ThemeVariables } from '../themes/vmo2-theme-variables';
import { salesNonVoltThemeVariables } from '../themes/sales-non-volt-theme-variables';

export interface Theme {
  name: string;
  properties: any;
}

export enum ThemeNames {
  DEFAULT = 'default',
  CARE = 'care',
  SALES = 'sales',
  MYVM = 'myvm',
  ALT = 'alt',
  CUSTOM = 'custom',
  SALES_VMO2 = 'sales_vmo2',
  SALES_SIM_BOLT_ON = 'sales_sim_bolt_on',
  VMO2 = 'vmo2',
  SALES_NON_VOLT = 'sales_non_volt',
}

// note! each new theme needs to contain all properties of the default
//eslint-disable-next-line
export const ThemeDefault: Theme = {
  name: ThemeNames.DEFAULT,
  properties: defaultThemeVariables
};
//eslint-disable-next-line
export const ThemeCare: Theme = {
  name: ThemeNames.CARE,
  properties: careThemeVariables
};
//eslint-disable-next-line
export const ThemeSales: Theme = {
  name: ThemeNames.SALES,
  properties: salesThemeVariables
};
//eslint-disable-next-line
export const ThemeMyvm: Theme = {
  name: ThemeNames.MYVM,
  properties: myvmThemeVariables
};
//eslint-disable-next-line
export const ThemeAlt: Theme = {
  name: ThemeNames.ALT,
  properties: altThemeVariables
};
//eslint-disable-next-line
export const ThemeSalesVmo2: Theme ={
  name:ThemeNames.SALES_VMO2,
  properties: salesVmo2ThemeVariables
};
//eslint-disable-next-line
export const ThemeSalesSimBoltOn: Theme ={
  name:ThemeNames.SALES_SIM_BOLT_ON,
  properties: salesSimBoltOnThemeVariables
};
//eslint-disable-next-line
export const ThemeVmo2: Theme ={
  name: ThemeNames.VMO2,
  properties: vmo2ThemeVariables
};
//eslint-disable-next-line
export const ThemeSalesNonVolt: Theme ={
  name:ThemeNames.SALES_NON_VOLT,
  properties: salesNonVoltThemeVariables
};
